import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import Spinner from '../../components/Spinner/Spinner';
import { Paper } from '@mantine/core';
import base from '../../apis';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
  },
}));

function OfficeStatus() {
  const [offices, setOffices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setIsLoading(true);
    base
      .get(
        `/operations/offices/?status=${pathname.includes('submitted') ? 'completed' : 'pending snr marketer approval'}`
      )
      .then(({ data }) => {
        if (data.length < 1) {
          toast.warn('No pending offices');
        }

        setOffices(data);
      })
      .catch((err) => {
        toast.err('Error getting offices');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [pathname]);
  const classes = useStyles();
  return (
    <>
      {isLoading && <Spinner />}
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={4}>
            {/* <TextField variant="outlined" inputProps={{ style: { padding: '5px' } }} /> */}
          </Grid>
        </Grid>
        <Box>
          <p>Submitted Offices</p>
        </Box>
        {offices.map((office) => (
          <Paper
            p="md"
            shadow="xs"
            sx={{ borderColor: 'var(--primary-color)', marginTop: '10px', cursor: 'pointer' }}
            key={office.id}
            component={Link}
            to={`${office.id}`}>
            <Grid container spacing={2}>
              <Grid item lg={1}>
                {new Date(office.date_updated).toLocaleDateString()}
              </Grid>
              <Grid item lg={5}>
                {office.branch}
              </Grid>
              <Grid item lg={3}>
                {office.address}
              </Grid>
              <Grid item lg={1}>
                {office.city}
              </Grid>
              <Grid item lg={2}>
                {office?.marketer?.user?.first_name} {office?.marketer?.user?.last_name}
              </Grid>
            </Grid>
          </Paper>
        ))}
      </div>
    </>
  );
}

export default OfficeStatus;
